// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const paperLantern = defineModel({
  id: "paper-lantern",
  batchId: "future",
  name: "Paper lantern",
  tags: ["scenery","paper","lantern","low-poly","age-of-mcp","future"],
  summary: "A paper lantern — soft, colourful festival lighting.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.14,
  variants: [
    { id: "variant-0", label: "Variant 1", parts: () => [
      { geometry: new THREE.CylinderGeometry(0.012, 0.016, 0.6, 5), color: "#6f4a26", position: [0, 0.3, 0] },
      { geometry: new THREE.CylinderGeometry(0.04, 0.05, 0.03, 8), color: "#33383d", position: [0, 0.73, 0] },
      { geometry: new THREE.SphereGeometry(0.12, 10, 7), color: "#ffe9b8", position: [0, 0.6, 0], scale: [1, 0.85, 1] },
      { geometry: new THREE.SphereGeometry(0.07, 8, 6), color: "#fff6da", position: [0, 0.6, 0] },
      { geometry: new THREE.TorusGeometry(0.12, 0.006, 4, 12), color: "#caa040", position: [0, 0.63, 0], rotation: [1.570796, 0, 0], scale: [1, 1, 0.85] },
      { geometry: new THREE.TorusGeometry(0.115, 0.006, 4, 12), color: "#caa040", position: [0, 0.56, 0], rotation: [1.570796, 0, 0], scale: [1, 1, 0.85] },
      { geometry: new THREE.CylinderGeometry(0.018, 0.018, 0.03, 6), color: "#d8b24a", position: [0, 0.48, 0] },
      { geometry: new THREE.ConeGeometry(0.02, 0.08, 5), color: "#d8b24a", position: [0, 0.42, 0], rotation: [3.141593, 0, 0] },
    ] },
    { id: "variant-1", label: "Variant 2", parts: () => [
      { geometry: new THREE.CylinderGeometry(0.012, 0.016, 0.6, 5), color: "#6f4a26", position: [0, 0.3, 0] },
      { geometry: new THREE.CylinderGeometry(0.04, 0.05, 0.03, 8), color: "#33383d", position: [0, 0.73, 0] },
      { geometry: new THREE.SphereGeometry(0.12, 10, 7), color: "#ff7a5a", position: [0, 0.6, 0], scale: [1, 0.85, 1] },
      { geometry: new THREE.SphereGeometry(0.07, 8, 6), color: "#ffb07a", position: [0, 0.6, 0] },
      { geometry: new THREE.TorusGeometry(0.12, 0.006, 4, 12), color: "#caa040", position: [0, 0.63, 0], rotation: [1.570796, 0, 0], scale: [1, 1, 0.85] },
      { geometry: new THREE.TorusGeometry(0.115, 0.006, 4, 12), color: "#caa040", position: [0, 0.56, 0], rotation: [1.570796, 0, 0], scale: [1, 1, 0.85] },
      { geometry: new THREE.CylinderGeometry(0.018, 0.018, 0.03, 6), color: "#b83a30", position: [0, 0.48, 0] },
      { geometry: new THREE.ConeGeometry(0.02, 0.08, 5), color: "#b83a30", position: [0, 0.42, 0], rotation: [3.141593, 0, 0] },
    ] },
    { id: "variant-2", label: "Variant 3", parts: () => [
      { geometry: new THREE.CylinderGeometry(0.012, 0.016, 0.6, 5), color: "#6f4a26", position: [0, 0.3, 0] },
      { geometry: new THREE.CylinderGeometry(0.04, 0.05, 0.03, 8), color: "#33383d", position: [0, 0.73, 0] },
      { geometry: new THREE.SphereGeometry(0.12, 10, 7), color: "#ffc24a", position: [0, 0.6, 0], scale: [1, 0.85, 1] },
      { geometry: new THREE.SphereGeometry(0.07, 8, 6), color: "#ffe49a", position: [0, 0.6, 0] },
      { geometry: new THREE.TorusGeometry(0.12, 0.006, 4, 12), color: "#caa040", position: [0, 0.63, 0], rotation: [1.570796, 0, 0], scale: [1, 1, 0.85] },
      { geometry: new THREE.TorusGeometry(0.115, 0.006, 4, 12), color: "#caa040", position: [0, 0.56, 0], rotation: [1.570796, 0, 0], scale: [1, 1, 0.85] },
      { geometry: new THREE.CylinderGeometry(0.018, 0.018, 0.03, 6), color: "#c79a3a", position: [0, 0.48, 0] },
      { geometry: new THREE.ConeGeometry(0.02, 0.08, 5), color: "#c79a3a", position: [0, 0.42, 0], rotation: [3.141593, 0, 0] },
    ] },
  ],
  animations: [],
});
